import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const OpenXAgentChatBubbleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="M2.25 2.25H15.75V11.25H6L2.25 15V2.25ZM3.75 3.75V11.38L5.38 9.75H14.25V3.75H3.75Z" />
  </SvgIcon>
);
